module.exports = __webpack_public_path__ + "img/37.8e3a160a.jpg";